import React, { FC } from 'react';
import { useNavigate } from 'react-router';
import { EVENT_QUERY_STRINGS } from '../../../../constants/eventsFairs.constants';
import { iconSize } from '../../../../constants/icon.constants';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import Dropdown, { TDropdownProps } from '../../../@shared/filters/components/dropdown';
import Icon from '../../../@shared/icon';
import { EventsListingModel } from '../../models/eventsListing.model';
import { EventListingFilters, TSelectedEventsFilters } from '../../types/eventsListing.types';
import { googleClickDropdownEvent } from '../../../../utils/analytics';

const DesktopFilter: FC<{
  model: EventsListingModel;
  selectedFilters: TSelectedEventsFilters;
  typeFilterDropdownOptions: TDropdownProps['dropdownOptions'];
  timelineFilterDropdownOptions: TDropdownProps['dropdownOptions'];
}> = ({ model, selectedFilters, typeFilterDropdownOptions, timelineFilterDropdownOptions }) => {
  const navigate = useNavigate();
  const { EVENT_TYPE, EVENT_TIMELINE } = EVENT_QUERY_STRINGS;

  const dropDownsProps = [
    {
      canShowFilter: model.canShowFilter(EventListingFilters.TIMELINE),
      options: timelineFilterDropdownOptions,
      queryKey: EVENT_TIMELINE,
      id: 'timeline-dropdown',
    },
    {
      canShowFilter: model.canShowFilter(EventListingFilters.TYPE),
      options: typeFilterDropdownOptions,
      queryKey: EVENT_TYPE,
      id: 'type-dropdown',
    },
  ];

  const shouldShowResetFilter = selectedFilters[EVENT_TYPE] !== '' || selectedFilters[EVENT_TIMELINE] !== '';

  const resetFilterCTA = shouldShowResetFilter && (
    <span className="events-listing-with-filter__reset" onClick={() => model.resetFilter(navigate)}>
      <DictionaryTerm keyword="cnhi-events-reset-filters" />
      <Icon iconName="action-refresh" size={iconSize['dsk']} color="primary" />
    </span>
  );

  return (
    <div className="events-listing-with-filter--dsk">
      <div className="events-filter">
        <div className="events-filter__dropdown-wrapper">
          {dropDownsProps?.map(({ queryKey, id, options, canShowFilter }) => {
            if (!options?.length || !canShowFilter) return null;
            return (
              <Dropdown
                key={id}
                dropdownOptions={options}
                id={id}
                handleOptionClick={(ind) => {
                  model.updateQueryByKey(navigate, queryKey, ind === 0 ? '' : (options?.[ind].id as string));
                  googleClickDropdownEvent(id, options[ind].title as string);
                }}
                selectedOptionInd={
                  selectedFilters[queryKey] ? options?.findIndex((_) => _.id?.toString() === selectedFilters[queryKey]) : 0
                }
              />
            );
          })}
        </div>
        {resetFilterCTA}
      </div>
    </div>
  );
};

export default DesktopFilter;
